import GetYourPost from './GetYourPost';
import { addOrientationChangeListener, removeOrientationChangeListener } from '../../utils/SessionUtils.js';
import { getBottomBarMobil } from '../../utils/PostUtils.js';

export default class GetYourPostTablet extends GetYourPost {
	constructor(props) {
		super(props);
		this.autoFocus = false;
	}

	getBottomBar(charCounter) {
		return getBottomBarMobil(charCounter, this);
	}

	observeOrientationChange(toggleModal) {
		if (toggleModal) {
			// pop-up is window is about to pop up
			addOrientationChangeListener(this);
		}
	}

	orientationChangeProcessor() {
		this.startPostProcess();
		this.state.parent.setState({ orientationChanged : true }); // nav will change the '+' button content
		removeOrientationChangeListener();
	}
}